/* eslint-disable no-use-before-define */
import styled, { css } from 'styled-components'
import { BlogThreshold as Threshold } from '../../constants/theme'
import Colors from '../../constants/colors'

const hideOnPhone = css`
  @media (max-width: ${Threshold.phone}) {
    display: none;
  }
`

export const Wrapper = styled.article`
  box-sizing: border-box;
  display: block;
  padding: 25px;
  flex-basis: 50%;
  max-width: 700px;
 
  @media (max-width: ${Threshold.tablet}) {
    flex-basis: 100%;
  }  
  
  @media (max-width: ${Threshold.phone}) {
    padding: 8px 25px;
  }
`

export const Container = styled.a`
  display: flex;
  flex-direction: row;
  min-height: 200px;
  height: 100%;
  position: relative;
  border-radius: 10px;
  box-shadow: 0 2px 10px 0 rgba(192, 192, 192, 0.5);
  text-decoration: none;
  
  :hover {
    .btn div {
      background-color: ${Colors.primaryHover};
      border-color: ${Colors.primaryHover};
      color: ${Colors.primary};
    }
    .picture {
      transform: scale(1.1);
    }
  }   
  .pictureWrapper {
    width: 300px;
    overflow: hidden;
    flex-shrink: 0;
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    
    .picture {
      height: 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      transition: 0.3s;
    }
  }
  
  @media (max-width: ${Threshold.phone}) {
    min-height: 140px;
    
    .pictureWrapper {
      width: 120px;
    }
  }
`
export const Content = styled.div`
  padding: 22px 15px 30px 23px;
  color: #000;
  font-size: 14px;
  line-height: 1.57;
  letter-spacing: normal;
  overflow-wrap: break-word;
  word-break: break-word;
  
  time {
    display: block;
    margin-bottom: 15px;
  }
  
  h3 {
    margin-bottom: 7px;
    font-family: StolzlMedium, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.57;
    letter-spacing: normal;
    text-transform: uppercase;
    color: #000;
  }
  
  .postPreviewText {
    p {
      margin: 0;
    }
    
    ${hideOnPhone}
  }
  
  .actionButton {
    position: absolute;
    right: -25px;
    bottom: -25px;
    
    .btn {
      display: inline-flex;
    }
    
    ${hideOnPhone}
  }
  
  @media (max-width: ${Threshold.phone}) {
    padding: 19px 13px 25px 15px;
    
    time {
      margin-bottom: 10px;
    }
    
    h3 {
      font-weight: normal;
      text-transform: none;
      font-family: StolzlRegular, sans-serif;
    }
  }
`

export const PromoWrapper = styled(Wrapper)`
  padding: 0;
  max-width: initial;
  
  .pictureWrapper {
    width: 61%;
  }
  
  ${Content} {
    padding: 54px 38px 32px 26px;
    
    time {
      margin-bottom: 35px;
    }
    
    h3 {
      margin-bottom: 16px;
      font-size: 20px;
      line-height: 1.5;
      letter-spacing: 2px;
    }
    
    .actionButton {
      position: static;
      margin-top: 29px;
      text-align: right;
    }
  }
  
  .postPreviewText {
    min-height: 100px;
  }
  
  @media (max-width: ${Threshold.tablet}) {
    .pictureWrapper {
      width: 50%;
    }
    
    ${Content} {
      padding: 37px 20px 20px 18px;
      
      time {
        margin-bottom: 31px;
      }
      
      h3 {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 1.88;
        letter-spacing: 1.6px;
      }
      
      .actionButton {
        margin-top: 18px;
      }
    }
  }  
  
  @media (max-width: ${Threshold.phone}) {
    padding: 0;
    
    ${Content} {
      padding: 18px;
      time {
        margin-bottom: 20px;
      }
      
      h3 {
        line-height: 1.57;
      }
    }
  }
`
